import { render, staticRenderFns } from "./bdd-preventive-measures.vue?vue&type=template&id=062faf67"
import script from "./bdd-preventive-measures.vue?vue&type=script&lang=js"
export * from "./bdd-preventive-measures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports